module.exports = __webpack_public_path__ + "assets/img_table-swoon.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/img_table-swoon.jpg
 ** module id = 134
 ** module chunks = 1
 **/